import { TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type Explanation = {
  deltas: any
  videoHTMLFrame?: string
  videoThumbnailUrl?: string
}

const reducerAction = {
  deltas: actionCreatorTypeGuard<Explanation, string>("deltas", "Explanation"),
  videoHTMLFrame: actionCreatorTypeGuard<Explanation, string>(
    "deltas",
    "Explanation"
  ),
  videoThumbnailUrl: actionCreatorTypeGuard<Explanation, string>(
    "deltas",
    "Explanation"
  ),
  __record: actionCreatorTypeGuard<TypeArray, Explanation>(
    "Explanation",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<Explanation>>(
    "create",
    "__create/Explanation"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof Explanation
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const explanationAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const explanationReducer = reducerTypeGuard<Explanation>()
  .case(...reducerAction.deltas)
  .case(...reducerAction.videoHTMLFrame)
  .case(...reducerAction.videoThumbnailUrl)
  .build()
